export const currencyFormat = (amount) => {
  if (isNaN(amount)) {
    return 0;
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
};
